import AbsModule from '../common/AbsModule';
import { serializeObject } from '../common/util';
import SearchAutoSuggestAutoSuggest from '../components/SearchAutoSuggestAutoSuggest';
import SearchAutoSuggestNcui from '../components/SearchAutoSuggestNcui';


export default class Search extends AbsModule {
    constructor(_data, _isShow = true) {
        super(_data, _isShow);

        // 검색 자동완성 기능
        // const searchAutoSuggestClass = this.moduleData.search.autoSuggestLibrary === 'ncui' && SearchAutoSuggestNcui || SearchAutoSuggestAutoSuggest
        const searchAutoSuggestClass = SearchAutoSuggestNcui;
        this.searchAutoSuggest = new SearchAutoSuggestNcui(this.moduleData);
    }

    startSetting() {
        if (typeof this.moduleData.search === 'undefined') {
            return;
        }

        this.showSearchBar = false;

        document.querySelector('.ncc-search')?.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        document.querySelectorAll('.ncc-search legend, .ncc-search-mobile__btn')?.forEach((v) => {
            v?.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.showSearchField();
            });
        });

        document.querySelector('.ncc-search-close')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.hideSearchField();
            return false;
        });

        // dom click handler (add/remove) - 동일한 콜백함수로 remove 해야하므로
        this.domClickHandlerCall = (e) => this.domClickHandler.call(this, e);

        this.searchAutoSuggest.start();
    }

    resetSearchField() {
        const input = document.querySelector('.ncc-search-input');
        const inputDelete = document.querySelector('.ncc-search-input-delete');

        if (input) input.value = '';
        if (inputDelete) inputDelete.style.display = 'none';
    }

    showSearchField() {
        if (this.showSearchBar) return;

        const search = document.querySelector('.ncc-search');
        const lnb = document.querySelector('.ncc-lnb');
        const input = document.querySelector('.ncc-search-input');

        search?.classList?.add('is-active');
        lnb?.classList?.add('search-active');

        setTimeout(() => {
            if (input) {
                input.click();
                input.focus();
            }
        }, 300);

        this.domClickEvent('add');
        this.showSearchBar = true;
    }

    hideSearchField() {
        const search = document.querySelector('.ncc-search');
        const lnb = document.querySelector('.ncc-lnb');

        search?.classList?.remove('is-active');
        lnb?.classList?.remove('search-active');

        this.resetSearchField();
        this.domClickEvent('remove');
        this.showSearchBar = false;
    }

    domClickEvent(type) {
        if (type === 'add') {
            document.addEventListener('click', this.domClickHandlerCall);
        } else {
            document.removeEventListener('click', this.domClickHandlerCall);
        }
    }

    domClickHandler(e) {
        const $ncCnb = document.querySelector('#nc-cnb');
        const $target = e.target;

        if (!$ncCnb.contains($target)) {
            this.hideSearchField();
        }
    }

    makeMarkup() {
        const { useGameStart, platformDownload, mobileGameDown } = this.moduleData;
        let positionCls = ' ncc-search--right-no';

        if (
            useGameStart === 'gameStart' ||
            (useGameStart === 'platformDownload' && Array.isArray(platformDownload))
        ) {
            positionCls = ' ncc-search--right-pc';
        }

        if (useGameStart === 'mobileGameDown') {
            if (mobileGameDown.showAndro && !mobileGameDown.showIos) {
                positionCls = ' ncc-search--right-mo1';
            }
            if (!mobileGameDown.showAndro && mobileGameDown.showIos) {
                positionCls = ' ncc-search--right-mo1';
            }
            if (mobileGameDown.showAndro && mobileGameDown.showIos) {
                positionCls = ' ncc-search--right-mo2';
            }
        }

        if (window.userData.isLogin) {
            positionCls += ' is-login';
        }

        return `
        <div class="ncc-search${positionCls}">
            <fieldset>
                <legend>Search</legend>
                <div class="ncc-search-wrap">
                    <input class="ncc-search-close" type="button" value="취소" title="취소"/>
                    ${this.searchAutoSuggest.markUp}
                </div>
            </fieldset>
        </div>`;
    }

    getMobileBtnTmpl() {
        const { search } = this.moduleData || {};
        const { isShow } = search || {};

        return isShow
            ? `<div class="ncc-search-mobile">
            <button type="button" class="ncc-search-mobile__btn">Search</button>
        </div>`
            : '';
    }
}
